/**
 * Overrides for Windmill's default theme, passed to <Windmill theme={...}>.
 *
 * Windmill's text fields rely on a form plugin this project doesn't load, so
 * they rendered with no border width and no padding: on a white card or popup
 * the box itself was invisible (Add Supplier, Add Customer, New Sale and more).
 * Setting it here fixes every <Input>, <Select> and <Textarea> at once. A
 * className on a field still wins, e.g. pl-9 next to a search icon.
 */
const windmillTheme = {
  input: {
    base: "block w-full text-sm focus:outline-none dark:text-gray-300 leading-5 rounded-md border px-3 py-2",
  },
  select: {
    base: "block w-full text-sm dark:text-gray-300 focus:outline-none rounded-md border px-3 py-2",
  },
  textarea: {
    base: "block w-full text-sm dark:text-gray-300 rounded-md focus:outline-none border px-3 py-2",
  },
};

export default windmillTheme;
